import { Injectable } from '@angular/core';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import {
  DvDropdownClientSideElement,
  DvTextareaElement,
} from '@devinco/ui/legacy';

@Injectable({ providedIn: 'root' })
export class MergeTripTabService {
  getTripDetailsElements = (): DvDynamicFormElement[] => [
    new DvDropdownClientSideElement({
      isClearable: true,
      colspan: 9,
      isMultipleSelectionEnabled: true,
      closeOnSelect: false,
      disabled: false,
      key: 'purpose',
      label: 'MergeTripTab.SelectPurpose',
      labelKeys: ['purpose'],
      valueKey: 'purpose',
      isCheckboxEnabled: true,
    }),
    new DvTextareaElement({
      colspan: 12,
      rowspan: 3,
      key: 'customPurpose',
      label: 'MergeTripTab.CustomPurpose',
    }),
  ];
}
